// export const VAR_ARE_ENTITY_CORE_POINT = `areEntitiesCorePoint`;
export const VAR_OBJECT = `geometry`;
export const VAR_ENTITY = `entity`;
export const VAR_ENTITIES = `entities`;
export const CLASS_CORE_POINT = `corePointClassFactory(${VAR_OBJECT})`;
export const CLASS_THREEJS_POINT = 'ThreejsPoint';
export const FUNC_GET_ENTITIES_ATTRIBUTE = 'getEntitiesAttribute';
export const FUNC_GET_ENTITY_ATTRIBUTE_VALUE = 'getEntityAttributeValue';
export const FUNC_GET_ENTITY_ATTRIBUTE_VALUE_FUNC = 'getEntityAttributeValueFunc';
